import { useCallback, useEffect } from "react";
import { useFirstMountState } from "react-use";
import { EMPTY_NOTIFICATION } from "@features/notifications/NotificationToasts/utlis/constants";
import useNotificationStore from "@features/notifications/store/useNotificationStore";

export const useEmptyNotification = () => {
  const isFirstMount = useFirstMountState();

  const [
    notification,
    setNotification,
    setIsNotificationLoading,
    setIsNotificationDisplayed,
  ] = useNotificationStore((store) => [
    store.notification,
    store.setNotification,
    store.setIsNotificationLoading,
    store.setIsNotificationDisplayed,
  ]);

  const notificationText = notification.text;

  const handleEmptyNotification = useCallback(() => {
    setIsNotificationLoading(false);
    setIsNotificationDisplayed(false);
  }, [setIsNotificationLoading, setIsNotificationDisplayed]);

  useEffect(() => {
    if (!isFirstMount) return;
    if (!notificationText) return;

    handleEmptyNotification();

    setNotification(EMPTY_NOTIFICATION);
  }, [
    handleEmptyNotification,
    notificationText,
    setNotification,
    isFirstMount,
  ]);

  return { handleEmptyNotification };
};
